export const lineVertexShader = `
uniform float amplitude;
uniform float posZ;
uniform float mode;
uniform float globalOpacity;

attribute vec3 customColor;

varying vec3 vColor;
varying float vOpacity;
varying float distToCamera;


void main() {
	vec3 posMultiplier = vec3(1.0,1.0,posZ);
	vec3 newPosition = (position * posMultiplier);
	
	vec4 cs_position = modelViewMatrix * vec4(position,1.0);
    distToCamera = -cs_position.y; //using just .y allows better fading out of twin peaks in the background

	vColor = customColor;
	vOpacity = globalOpacity;

	gl_Position = projectionMatrix * modelViewMatrix * vec4( newPosition, 1.0 );

}
`